import React from 'react';
import { Typography } from '@mui/material';


const Dropdown = ({ options, selected, setSelected, text, width, height,margin,marginDropdown }) => {
    const dropdownStyles = {
        padding: '10px',
        margin: marginDropdown ||'10px 10px 10px 10px',
        width: width || '140px', // Default width is 140px, but can be overridden using props
        height: height || 'auto', // Default height is auto, but can be overridden using props
        border: '1px solid #ccc',
        '@media (min-width:600px)': { 
            width: width || '140px' // Override the width for media query if provided
        }
    };

    const dropdownContainerStyles = {
        alignItems: 'center',
        gap: '10px',
        margin: margin ||'0px 0px 0px 20px',
    }

    return (
        <div className='d-flex' style={dropdownContainerStyles}>
            <Typography width="200px" sx={{textAlign:"left"}}>{text}</Typography>
            <select
                value={selected}
                onChange={setSelected}
                style={ dropdownStyles }
            >
                {options.map((option) => (
                    <option key={option} value={option}>{option}</option>
                ))}
            </select>
        </div>
    );
}


export default Dropdown;